module.exports = __webpack_public_path__ + "img/character-grandpa-sad.716f495e.svg";